import React, { memo, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import usePageContent from '../../hooks/usePageContent';
import Nav from 'react-bootstrap/Nav';
import useProductList from '../../hooks/useProductList';
import { useAppConfig } from '../../context/AppConfigContext';
import useProductCategoryByStore from '../../hooks/useProductCategoryByStore';
import SellerStoreHome from './SellerStoreHome';
import SellerStoreProducts from './SellerStoreProducts';
import SellerStoreCategory from './SellerStoreCategory';

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const SellerStoreNew = ({ store, storeId, productCategory }) => {
    const { lang } = useParams();
    const { config } = useAppConfig();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const { fetchPageContent, data, status, error, resetStatus } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    const currency = config?.currency === 'USD' ? '$' : config?.currency === 'AUD' ? 'AU$' : 'Rp';

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: 'home', field: 'HotDealsToday', language: 'en-US' });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === '' ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status]);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setTimeLeft(getCountdown());
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, []);

    //nav pindah kesini

    const [filterCategoryId, setFilterCategoryId] = useState(undefined);
    const [page, setPage] = useState(0);

    // const {
    //     fetchProductCategoryByStore,
    //     data: productCategory,
    //     status: productCategoryStatus,
    //     error: productCategoryError
    // } = useProductCategoryByStore();

    const {
        fetchProductList,
        data: productList,
        total: productListTotal,
        status: productListStatus,
        error: productListError
    } = useProductList();

    // useEffect(() => {
    //     if (store && store.userId) {
    //         fetchProductCategoryByStore(store.userId);
    //     }
    // }, [store]);

    const setSelectedGallery = (id) => {
        setFilterCategoryId(id);
        setPage(0);
    };

    const setAllCategory = () => {
        setFilterCategoryId(undefined);
        setPage(0);
    };

    useEffect(() => {
        if (!storeId) return;
        // console.log("check fetching categoryid", filterCategoryId);
        fetchProductList({
            // categoryIds: keyword ?? filterCategoryId,
            categoryIds: filterCategoryId,
            companyId: storeId,
            // sortBy: sortBy.split("-")[0],
            // sortType: sortBy.split("-")[1],
            skip: 0,
            take: 20
        });
    }, [filterCategoryId, page, storeId]);

    useEffect(() => {
        //console.log(productListStatus);
        if (productListStatus === 'done') {
            // setIsLastPage(page + 1 === Math.ceil(productListTotal / 20));
            // setIsFirstPage(page === 0);
        }
    }, [productListStatus]);

    // console.log("productList data displayed" , productList)

    //nav function

    const itemCount = productList?.length ?? 0;
    const safeSlidesToShow = Math.min(4, itemCount || 1);

    const settings = {
        dots: false,
        arrows: itemCount > 1,
        infinite: false,
        speed: 600,
        slidesToShow: safeSlidesToShow,
        slidesToScroll: 1,
        autoplay: itemCount > safeSlidesToShow,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: Math.min(3, itemCount || 1)
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: Math.min(2, itemCount || 1)
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    const [tab, setTab] = useState('home');
    const [selectedCategoryId, setSelectedCategoryId] = useState(undefined);

    return (
        <>
            <section className="categoryNav">
                <div className="container">
                    <div
                        className="d-flex justify-content-start"
                        style={{
                            borderBottom: '1px solid #e6e6e6',
                            color: 'gray',
                            fontFamily: 'Quicksand',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        <Link
                            to="#"
                            style={{
                                padding: '0.5rem 1rem',
                                color: tab === 'home' ? '#970a02' : '#828282',
                                borderBottom: tab === 'home' ? '2px solid #970a02' : '0'
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                setTab('home');
                            }}
                        >
                            Home
                        </Link>
                        <Link
                            to={'#'}
                            style={{
                                padding: '0.5rem 1rem',
                                color: tab === 'product' ? '#970a02' : '#828282',
                                borderBottom: tab === 'product' ? '2px solid #970a02' : '0'
                            }}
                            className={''}
                            onClick={(e) => {
                                e.preventDefault();
                                setTab('product');
                            }}
                        >
                            Product
                        </Link>
                        <Link
                            to={'/products'}
                            style={{
                                padding: '0.5rem 1rem',
                                color: tab === 'category' ? '#970a02' : '#828282',
                                borderBottom: tab === 'category' ? '2px solid #970a02' : '0'
                            }}
                            className={''}
                            onClick={(e) => {
                                e.preventDefault();
                                setTab('category');
                            }}
                        >
                            Category
                        </Link>
                    </div>
                </div>
            </section>

            {tab === 'home' && (
                <SellerStoreHome
                    store={store}
                    storeId={storeId}
                    productCategory={productCategory}
                    onSelectCategory={() => {
                        setSelectedCategoryId(undefined);
                        setTab('product');
                    }}
                />
            )}
            {tab === 'product' && (
                <SellerStoreProducts storeId={storeId} productCategory={productCategory} categoryId={selectedCategoryId} />
            )}
            {tab === 'category' && (
                <SellerStoreCategory
                    productCategory={productCategory}
                    onSelectCategory={(categoryId) => {
                        setSelectedCategoryId(categoryId);
                        setTab('product');
                    }}
                />
            )}
        </>
    );
};

export default SellerStoreNew;
